$(document).on('keydown ',function(e) {
 const ctrl = e.metaKey || e.ctrlKey

 // auto capture CTRL + S
 if (ctrl && e.key == 's') {
  const target = $(document).find(`input[type=submit]`).last()
  if (target[0]) {
    e.preventDefault()
    target.click()
    return
  }
 }

 // put key combination in data-key attribute to trigger onclick event
 // <button data-key="Escape" onclick="..."
 // <input type="submit" data-key="ctrl+s"
 const code = ctrl ? `ctrl+${e.key}` : e.key
 const target = $(document).find(`*[data-key='${code}']`)
 if (target[0] && target.data('key') == code) {
  target.click()
 }

 // refrehs side dialog if open
 if (SideDialog.isOpen() && code == 'ctrl+r') {
  e.preventDefault()
  SideDialog.reload()
 }
});

